//Kickoff google analytics if this is a production build (not stage)

export function initGoogleAnalytics() {
  if (process.env.REACT_APP_FIREBASE_CONFIG === "production") {

    /* eslint-disable */

    //Initialize Google Analytics
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date();
      a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

    //execute Google Analytics
    window.ga('create', 'UA-75243711-1', 'auto')

    /* eslint-enable */

  }
}


// WEBPACK FOOTER //
// ./src/init-google-analytics.js